import SweetAlert from "./components/SweetAlert";
export default SweetAlert;
//# sourceMappingURL=index.js.map